module.exports = __webpack_public_path__ + "img/filter.4312ce5d.svg";